<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="TEXT">
<p class="pt"><a class="page" id="page.41"></a><a class="xref" href="#/eernicot04nu0005#rTEXT">Text and Commentary</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-nicot04nu-0016.vue?2c8cbb00